(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["food-index-fv"] && !Shopify.designMode) return;
  try {
    
  const fv_main_sliders = [...document.querySelectorAll(".fv_main_slider")]
  fv_main_sliders.map(fv_main_slider=>{
    const is_slide = [...fv_main_slider.querySelectorAll("li")].length > 1
    console.log(is_slide)
    if(is_slide){
      $(fv_main_slider).slick({
        autoplaySpeed: 3000,
        dots: true,
        autoplay:true,
        infinite:true,
        slidesToShow:1,
      })
    }
  })
  
const is_fv_slide = document.querySelector(".fv-slide-body")

    if(is_fv_slide){
      $(is_fv_slide).slick({
        autoplaySpeed: 1500,
        fade: true,
        speed:2000,
        arrows:false,
        dots: false,
        autoplay:true,
        infinite:true,
        slidesToShow:1,
      })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_mypage_renew"] && !Shopify.designMode) return;
  try {
    
    /* ピッチインピッチアウトによる拡大縮小を禁止 */
    document.documentElement.addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) { e.preventDefault(); }
    }, { passive: false });
    /* ダブルタップによる拡大を禁止 */
    var t = 0;
    document.documentElement.addEventListener('touchend', function (e) {
      var now = new Date().getTime();
      if ((now - t) < 350) {
        e.preventDefault();
      }
      t = now;
    }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_food"] && !Shopify.designMode) return;
  try {
    
    /* ピッチインピッチアウトによる拡大縮小を禁止 */
    document.documentElement.addEventListener('touchstart', function(e) {
        if (e.touches.length >= 2) {
            e.preventDefault();
        }
    }, {
        passive: false
    });
    /* ダブルタップによる拡大を禁止 */
    var t = 0;
    document.documentElement.addEventListener('touchend', function(e) {
        var now = new Date().getTime();
        if ((now - t) < 350) {
            e.preventDefault();
        }
        t = now;
    }, false);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mypage"] && !Shopify.designMode) return;
  try {
    
    /* ピッチインピッチアウトによる拡大縮小を禁止 */
    document.documentElement.addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) { e.preventDefault(); }
    }, { passive: false });
    /* ダブルタップによる拡大を禁止 */
    var t = 0;
    document.documentElement.addEventListener('touchend', function (e) {
      var now = new Date().getTime();
      if ((now - t) < 350) {
        e.preventDefault();
      }
      t = now;
    }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mypage_renew"] && !Shopify.designMode) return;
  try {
    
  /* ピッチインピッチアウトによる拡大縮小を禁止 */
  document.documentElement.addEventListener(
    'touchstart',
    function (e) {
      if (e.touches.length >= 2) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  /* ダブルタップによる拡大を禁止 */
  var t = 0;
  document.documentElement.addEventListener(
    'touchend',
    function (e) {
      var now = new Date().getTime();
      if (now - t < 350) {
        e.preventDefault();
      }
      t = now;
    },
    false
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_none"] && !Shopify.designMode) return;
  try {
    
    /* ピッチインピッチアウトによる拡大縮小を禁止 */
    document.documentElement.addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) { e.preventDefault(); }
    }, { passive: false });
    /* ダブルタップによる拡大を禁止 */
    var t = 0;
    document.documentElement.addEventListener('touchend', function (e) {
      var now = new Date().getTime();
      if ((now - t) < 350) {
        e.preventDefault();
      }
      t = now;
    }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mypage_home"] && !Shopify.designMode) return;
  try {
    

const url = location.href
    const _url = new URL(url)
    if(_url.searchParams.get("hbSubscriptionPath")) {
        document.getElementById('home').innerHTML = ""
        document.getElementById('home').style.paddingTop = "24px"
        document.getElementById('home').style.paddingBottom = "0px"
    } else {
        document.getElementById('huckleberry-subscription-customer-portal-wrap-experimental').remove()
    }
window.addEventListener("message", (response) => {
    // 取得した内容を利用した処理
    console.log(`get message ${response.data.action}`)
    if(response.data.action == "scrollToTop"){
        window.scrollTo({
            top:0,
            behavior:'smooth'
        })
    }
}) 

  } catch(e) { console.error(e); }
})();
})();
